import React, { useState, useEffect } from 'react';
import { TextField, List, ListItem, ListItemText, Button, Switch, FormControlLabel, FormGroup, Checkbox, CircularProgress } from '@material-ui/core';
import { DietInfo } from './DietInfo';
import { editDietInfo } from './index'
import { useNotify } from "react-admin";
export function CustomerInfo(props: any) {
    const { allDietTypes, checkedState, onSelectedDietsChange, refetchChild } = props;
    const { id, sid, profileNumber, maritalStatus, profession, bloodGroup, diets } = props.user;
    let [isEditCustomerInfo, setIsEditCustomerInfo] = useState(false)
    let [isLoading, setIsLoading] = useState(false)
    let [values, setValues] = useState({
        customerId: id,
        profileNumber: profileNumber || null
    })
    let [saleApiStates, setSaleApiStates] = useState<boolean[]>(Array(diets.length).fill(false));
    const [selectedDiets, setSelectedDiets] = useState<any>([]);
    const [editStates, setEditStates] = useState<boolean[]>(Array(diets.length).fill(false));
    const notify = useNotify()
    const handleDietCheckboxChange = (dietId: any) => {
        setSelectedDiets((prevSelectedDiets: any) => {
            if (prevSelectedDiets.includes(dietId)) {
                return prevSelectedDiets.filter((id: any) => id !== dietId);
            } else {
                return [...prevSelectedDiets, dietId];
            }
        });
    };
    const checkSaleApiDisablity = (index: any) => {
        console.log("index", index);
        if (diets[index].saleApiRequestId !== null) {
            return false
        } else {
            return true
        }

    }
    const checkTab = (index: any) => {
        if (!editStates[index] && !saleApiStates[index]) {
            return '1'
        }
        if (saleApiStates[index]) {
            return '2'
        }
        if (editStates[index]) {
            return '3'
        }
    }
    const switchIsEdit = (index: number, state: any) => {
        const newEditStates = [...editStates];
        newEditStates[index] = state;
        if (saleApiStates[index]) {
            switchSaleApiStates(index, false)
        }
        checkTab(index)
        setEditStates(newEditStates);
    };
    const switchSaleApiStates = (index: number, state: any) => {

        const newsaleApiStates = [...saleApiStates];
        newsaleApiStates[index] = state;
        if (editStates[index] && newsaleApiStates[index]) {
            switchIsEdit(index, false)
        }
        setSaleApiStates(newsaleApiStates);
    };
    const paymentStatus = (diet:any)=>{
        if (diet.discountName !== null) {
            return diet.discountName
        }
        else if(diet.saleApiRequestId !== null){
            return 'پرداخت خارجی لیموناد'
        }
        else{
            return 'نامشخص'
        }
    }
    const submitEdit = async (e: any) => {
        setIsLoading(true)
        try {
            const response = await editDietInfo(values)
            if (response && response.data.data && response.data.data.sid) {
                refetchChild()
                setIsLoading(false)
                setIsEditCustomerInfo(!isEditCustomerInfo)
            }
            if (response && response.data.err) {
                setIsLoading(false)
                setIsEditCustomerInfo(!isEditCustomerInfo)
                notify(` کد${response.data.err.code} - ${response.data.err.details.messages[0]}`)
            }

        } catch (error) {
            setIsLoading(false)
            notify(`خطایی پیش آمده است`)
        }
    }
    useEffect(() => {
        if (checkedState) {
            setSelectedDiets([]);
        }
    }, [checkedState]);

    useEffect(() => {
        onSelectedDietsChange(selectedDiets);
    }, [selectedDiets, onSelectedDietsChange]);
    return (
        < >
            <div style={{ margin: "4px", }}>
                <p style={{ color: "#01579b", marginTop: "5px", marginBottom: "5px", fontWeight: "900", fontSize: "18px" }}>CustomerInfo list</p>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ marginRight: "20px" }}>

                        <Button style={{ width: "80px", height: "30px", borderRadius: "8px", marginLeft: "5px", background: "#d2d2d2", marginRight: "5px" }} onClick={() => setIsEditCustomerInfo(!isEditCustomerInfo)}> {isEditCustomerInfo ? "بازگشت" : "ویرایش"} </Button>
                        {isEditCustomerInfo ?
                            <Button
                                style={{ width: "80px", height: "30px", borderRadius: "8px", marginLeft: "10px", border: "1px solid #63b8f3", marginRight: "5px" }}
                                color="primary"
                                onClick={(e) => submitEdit(e)}>   {isLoading ? <CircularProgress size={20} /> : <span>ثبت</span>}
                            </Button>
                            : <div></div>
                        }
                    </div>
                    {isEditCustomerInfo ?
                        <div>
                            <form style={{ display: "flex", flexDirection: "row" }} action="" onSubmit={(e) => submitEdit(e)}>
                                <TextField
                                    style={{ fontFamily: "IranSans-Light", marginLeft: "5px" }}
                                    fullWidth
                                    onChange={(e: any) => setValues({ ...values, profileNumber: e.target.value })}
                                    value={values.profileNumber}
                                    label="    شماره پرونده "
                                    variant="outlined"
                                    size="small"
                                >

                                </TextField>
                            </form>

                        </div>
                        :
                        <div style={{ fontFamily: "IranSans-Medium", width: "100%", fontSize: "12px", display: "flex", flexWrap: "wrap", padding: "5px", borderRadius: "4px" }}>
                            <div style={{ marginLeft: "5px" }}>   <span style={{ margin: "2px", fontWeight: "700" }}>شناسه :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{id ? id : '-'}</span></div>
                            <div style={{ marginLeft: "5px" }}><span style={{ margin: "2px", fontWeight: "700" }}>شناسه یکتا :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{sid ? sid : '-'}</span></div>
                            <div style={{ marginLeft: "5px" }}> <span style={{ margin: "2px", fontWeight: "700" }}>شماره پرونده :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{profileNumber ? profileNumber : '-'}</span></div>
                            <div style={{ marginLeft: "5px" }}><span style={{ margin: "2px", fontWeight: "700" }}>وضعیت تاهل  :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{maritalStatus ? maritalStatus : '-'}</span></div>
                            <div style={{ marginLeft: "5px" }}> <span style={{ margin: "2px", fontWeight: "700" }}>شغل : </span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{profession ? profession : '-'}</span></div>
                            <div style={{ marginLeft: "5px" }}><span style={{ margin: "2px", fontWeight: "700" }}>گروه خونی :</span>  <span style={{ marginLeft: "4px", color: "#616161" }}>{bloodGroup ? bloodGroup : '-'}</span></div>
                        </div>
                    }
                </div>


            </div>
            <div style={{ margin: "4px", width: "100%" }}>

                <p style={{ color: "#01579b", marginTop: "5px", marginBottom: "10px", fontWeight: "900", fontSize: "18px", borderTop: "1px solid #d2d2d2" }}>Diets list</p>
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
                    {diets.map((diet: any, index: number) => (
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: "33%" }}>
                            <div style={{
                                display: "flex", flexDirection: "column", alignItems: "start",
                                background: "#e7e7e7", width: "90%", borderTopLeftRadius: "5px", borderTopRightRadius: "5px", padding: "5px", border: "1px solid #d2d2d2",
                                borderBottom: "none",
                            }}>
                            <div style={{
                                display: "flex", flexDirection: "row", alignItems: "center",
                                 width: "90%", height: "50px", 
                            }}>
                                <FormControlLabel
                                    key={diet.id}
                                    control={<Checkbox disabled={checkedState} checked={selectedDiets.includes(diet.id)} onChange={() => handleDietCheckboxChange(diet.id)} />}
                                    label={` `}
                                />
                            </div>
                            <div style={{width:"100%"}}>
                            <Button
                                    style={{ width: "25%", height: "30px", borderRadius: "0px", background: checkTab(index) === '1' ? "#02579b" : "#d2d2d2", color: checkTab(index) === '1' ? "#d2d2d2" : "#02579b", fontSize: "10px" }}
                                    onClick={() => switchIsEdit(index, false)}>
                                     رژیم
                                </Button>
                                <Button
                                    style={{ width: "25%", height: "30px", margin: "0px 2px 0px 2px", borderRadius: "0px", background: checkTab(index) === '3' ? "#02579b" : "#d2d2d2", color: checkTab(index) === '3' ? "#d2d2d2" : "#02579b", fontSize: "10px" }}
                                    onClick={() => switchIsEdit(index, true)}>
                                    ویرایش 
                                </Button>
                                {!checkSaleApiDisablity(index) ?
                                    <Button
                                        style={{ width: "25%", height: "30px", borderRadius: "0px", background: checkTab(index) === '2' ? "#02579b" : checkSaleApiDisablity(index) ? "#939393" : "#d2d2d2", color: checkTab(index) === '2' ? "#d2d2d2" : checkSaleApiDisablity(index) ? "#fff" : "#02579b", fontSize: "10px" }}
                                        disabled={checkSaleApiDisablity(index)}
                                        onClick={() => switchSaleApiStates(index, true)}>
                                        پرداخت
                                </Button> : <div></div>}
                            </div>
                            <div>
                                <div  style={{ fontFamily: "IranSans-Medium", margin: "5px",color:"#031421" }}>  
                                <span style={{fontSize:"12px"}}>وضعیت پرداخت:</span>
                                <span style={{fontSize:"12px",color:"#319ac4",marginRight:"5px"}}>{paymentStatus(diet)}</span> 
                                </div>
                            </div>
                            </div>
                            < DietInfo
                                key={index}
                                diet={diet}
                                allDietTypes={allDietTypes}
                                issaleApiStates={saleApiStates[index]}
                                isEdit={editStates[index]}
                                refetchChild={refetchChild}
                                switchIsEdit={() => switchIsEdit(index, editStates[index])}
                            />
                        </div>
                    ))}
                </div>

            </div>


        </>
    )
}

